import { ImportUsersBase } from "./ImportUsersBase";

export const ImportManagers = () => (<ImportUsersBase defaultRoleGroup="Driver manager" />);